// /home/ananun/fluorescence.pro/admin/src/helpers/history.jsx
// history.jsx

import { createBrowserHistory as history } from "history";

export default history();
